import { classInstance } from '@/shared/helpers/helpers';
import { Form } from '@/shared/form/form';
import { subjectRequest } from '@/api/request/subject.js';

export class SubjectForm {
	constructor(selector) {
		this.$container = selector;

		if (!this.$container) return;

		this.init();
	}

	init() {
		classInstance.set(this.$container, { contactForm: this });
		this.$button = this.$container.querySelector('button[type="submit"]');
		this.instance = new Form(this.$container);

		this.$container.addEventListener('submit', this.submitHandler.bind(this));
		this.$container.addEventListener('input', this.inputHandler);
		this.$button.disabled = true;

		// адрес, на который отправляется аджакс-запрос, берётся из атрибута data-url скрытого инпута с классом subject-form__url:
		this.$addressInput = this.$container.querySelector('.subject-form__url'); 

		this.captchaInitObserver();
	}

	destroy() {
		classInstance.del(this.$container, 'contactForm');
		this.$container.removeEventListener('submit', this.submitHandler);
	}

	reinit() {
		this.destroy();
		this.init();
	}

	inputHandler = () => {
		const result = this.instance.formCheck(true);
		this.$button.disabled = !result;
	};

	captchaInitObserver = () => {
		const callback = (mutationList) => {
			mutationList.forEach((mutation) => {
				const captchaInput = Array.from(mutation.addedNodes).find((node) => node.name === 'smart-token');
				if (captchaInput) {
					captchaInput.required = true;
					captchaInput.dataset.rule = 'captcha';
					this.reinit();
				}
			});
		};

		const observer = new MutationObserver(callback);

		observer.observe(this.$container, { childList: true, subtree: true });
	};

	submitHandler(event) {
		event.preventDefault();

		if (!this.instance.formCheck(false)) return;

		this.$button.classList.add('loading');

		if (this.$addressInput?.dataset.url) subjectRequest(new FormData(this.$container), this.$addressInput.dataset.url).then((response) => {
			this.$button.classList.remove('loading');
			if (response.status !== 'success') {
				app.notify.append({
					type: response.status,
					delay: '10000',
					content: response.message,
				});
			} else {
				app.modal.open('#modal-subject-success');
			}
			this.$container.reset();
		});
	}
}
